<template>
  <button
    @click="driveIconClicked()"
    type='button'
    class='button is-warning w-100-if-mobile mb-4-if-mobile'
    name='import video'>
    + Import from Google Drive
  </button>
</template>

<script>
/* global gapi google */
import axios from 'axios'

export default {
  name: 'GoogleFilePicker',
  data () {
    return {
      loading: false,
      pickerApiLoaded: false,
      developerKey: 'AIzaSyA_sMWznxkAcnkQtVrCsIsVon7KkIjNPwg',
      clientId: '84208290229-nchpgk8e2rtnj7nbhtvmur1tq0t6896p.apps.googleusercontent.com',
      scope: 'https://www.googleapis.com/auth/drive.readonly',
      oauthToken: null
    }
  },
  mounted () {
    const gDrive = document.createElement('script')
    gDrive.setAttribute('type', 'text/javascript')
    gDrive.setAttribute('src', 'https://apis.google.com/js/api.js')
    gDrive.async = true
    document.head.appendChild(gDrive)
  },
  props: {},
  methods: {
    async driveIconClicked () {
      console.log('Clicked')
      await gapi.load('auth2', () => {
        console.log('Auth2 Loaded')
        gapi.auth2.authorize(
          {
            client_id: this.clientId,
            scope: this.scope,
            immediate: false
          },
          this.handleAuthResult
        )
      })
      gapi.load('picker', () => {
        console.log('Picker Loaded')
        this.pickerApiLoaded = true
        this.createPicker()
      })
    },
    handleAuthResult (authResult) {
      console.log('Handle Auth result', authResult)
      if (authResult && !authResult.error) {
        this.oauthToken = authResult.access_token
        this.createPicker()
      }
    },
    createPicker () {
      console.log('Create Picker', google.picker)
      if (this.pickerApiLoaded && this.oauthToken) {
        const picker = new google.picker.PickerBuilder()
          .addView(google.picker.ViewId.DOCS_VIDEOS)
          .setOAuthToken(this.oauthToken)
          .setDeveloperKey(this.developerKey)
          .setCallback(this.pickerCallback)
          .build()
        picker.setVisible(true)
      }
    },
    async pickerCallback (data) {
      if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
        const reqData = {
          access_token: this.oauthToken,
          file_id: data.docs[0].id,
          mime_type: data.docs[0].mimeType,
          name: data.docs[0].name,
          size_bytes: data.docs[0].sizeBytes
        }
        await axios.post('/api/v1/fetch-file-from-google-drive/', reqData,
          { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
        .then(() => {
          this.$router.push('/')
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// GoogleFilePicker.vue?365ecb64